import { BaseFormComponent } from "../../base-form/base-form.component";
import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { SolicitacaoTecnicaService } from "../../../../services/solicitacao-tecnica.service";
import { AmostraService } from "../../../../services/amostra.service";
export interface IAmostraFormulario {
	id: number;
	nome: string;
	amostraId: number;
	amostraFormularioItens: IAmostraFormularioItens[];
}
export interface IAmostraFormularioItens {
	amostraFormularioId: number;
	descricao: string;
}
@Component({
	selector: 'app-modal-amostra-formulario',
	templateUrl: './modal-amostra-formulario.component.html',
	styleUrls: ['./modal-amostra-formulario.component.scss']
})
export class ModalAmostraFormularioComponent extends BaseFormComponent implements OnInit {
	public dadosItem: IAmostraFormulario;
	public descricao: string = '';
	public nomeFormulario: string = '';
	public visualizar: boolean;
	public titulo: string = '';

	constructor(
		route: ActivatedRoute,
		toastr: ToastrService,
		router: Router,
		localeService: BsLocaleService,
		public matDialog: MatDialog,
		private ugService: SolicitacaoTecnicaService,
		private amostraService: AmostraService,
		private dialogRef: MatDialogRef<ModalAmostraFormularioComponent>,
		@Inject(MAT_DIALOG_DATA) public data
	) {
		super(route, toastr, router, localeService, matDialog);

		this.nomeFormulario = data?.nomeAmostra ? data.nomeAmostra + ' - Formulário' : '';
		this.visualizar = !!data?.visualizar;

		this.dadosItem = {
			id: 0,
			nome: this.nomeFormulario,
			amostraId: 0,
			amostraFormularioItens: []
		};

		if (data?.dados) {
			this.dadosItem = {
				...this.dadosItem,
				...data.dados,
				amostraFormularioItens: data.dados.amostraFormularioItens || []
			};
		}

		if (this.visualizar) {
			this.titulo = 'Visualizar';
		} else if (this.dadosItem?.id && this.dadosItem.amostraFormularioItens.length > 0) {
			this.titulo = 'Editar';
		} else {
			this.titulo = 'Preencher';
		}
	}

	ngOnInit(): void {}

	public adicionarItem(): void {
		const descricao = this.descricao?.trim();
		if (!descricao) return;

		if (!this.dadosItem.amostraFormularioItens) {
			this.dadosItem.amostraFormularioItens = [];
		}

		if (this.dadosItem.amostraFormularioItens.length >= 31) {
			this.exibirMensagemAlerta('Limite máximo de 31 itens atingido.', true, 'Não é possível adicionar mais. Use arquivos.');
			return;
		}

		const novoItem: IAmostraFormularioItens = {
			amostraFormularioId: this.dadosItem.id,
			descricao: descricao
		};

		this.dadosItem.amostraFormularioItens.push(novoItem);
		this.descricao = '';
	}

	trackByIndex(index: number, item: any): number {
		return index;
	}

	excluir(itemParaExcluir: IAmostraFormularioItens): void {
		this.dadosItem.amostraFormularioItens = this.dadosItem.amostraFormularioItens.filter(
			item => item !== itemParaExcluir
		);
	}

	salvar(): void {
		this.dialogRef.close(this.dadosItem);
	}

	cancelar(): void {
		this.dialogRef.close();
	}
}

